import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import Banner from '../components/Banner';
import Contact from '../components/Contact';
import Sponsors from '../components/Sponsors';

const Contacto = () => {
  const [sponsors, setSponsors] = useState(null);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_URL}/sponsors/cali`)
    .then(res => res.json())
    .then(
      (res) => {
        setSponsors(res.sponsors);
      },
      (error) => {
        console.error(error);
      }
    )
  }, []);

  return (
    <Layout>
      <Banner id={11} city="home" thumb="/cali/logo_cali.PNG" />
      <div className="container">
        <div className="row">
          <div className="col-12 text-center">
            <h1>CONTÁCTENOS</h1>
          </div>
        </div>
        <Contact city="home" />
      </div>
      {sponsors &&
        <Sponsors
          customClass="--home"
          items={sponsors}
        />
      }
    </Layout>
  );
}

export default Contacto;
